import React, { useState } from 'react'
import './Logo.css'

const lines = Array.from({length: 5}, (e, i) => {
    const x1 = 0, x2 = 120;
    const y = 15 * i;
    return [[x1, y], [x2, y]]
})

const createLinePath = (arr) => {
    const path = `M${arr.map((item, i) => [item[0], item[1]]).join('L')}`;
    return path
}
    




const Logo = ({purple = false}) => {
    
    const [ hover, setHover ] = useState(false)
    
    return ( 
        <svg 
            viewBox="0 0 100 100"
            className="logo"
            onMouseEnter={() => setHover(!hover)}
            onMouseLeave={() => setHover(!hover)}
            >
            #0b3c07
            {lines.map((line,i) => 
                <path 
                    key={i}
                    d={createLinePath(lines[i])}
                    stroke="#53ff44"
                    strokeWidth="3"                    
                />    
            )}
            <rect x={hover ? '5': "45"} y={hover ? '5': "30"} width={hover ? '110' : '30'} height={hover ? '50' : '10'} fill={hover ? '#dfa362' : "#3c1c07"}/>
        </svg>
     );
}
 
export default Logo;
